import { render, staticRenderFns } from "./SplaReportEdit.vue?vue&type=template&id=acf71960&"
import script from "./SplaReportEdit.vue?vue&type=script&lang=js&"
export * from "./SplaReportEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports